/**
 * Compare two strings using natural sort order.
 * Numbers within strings are compared numerically.
 *
 * Example: "Sequence 2" comes before "Sequence 10"
 */
function naturalCompare(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}

export { naturalCompare };
